import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function ProctoringIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M5.647 14.438h4.706m.151-9.527a1.025 1.025 0 1 1-1.527-1.185 3 3 0 1 0 1.527 1.185M13 6.609c0 2.788-2.239 5.047-5 5.047S3 9.396 3 6.61s2.239-5.046 5-5.046 5 2.26 5 5.046" /></svg>
  );
}

export default ProctoringIcon;
